export default () => {
    const valueItems = document.querySelectorAll('.value-item');
    const valueImg = document.querySelector('#value-img');
    const valueMain = document.querySelector('#value-main');
    const valueText = document.querySelector('#value-text');

    const coreValues = [
        {
            main: '一人一人に向き合ったキャリア面談',
            text: '私たちは、個々人のニーズや目標に合わせたキャリア面談を提供しています。一人ひとりに向き合い、あなたの強みやスキル、興味を理解し、情報を提供することで、より良いキャリアの決断をサポートします。',
            img: 'value01.png',
        },
        {
            main: '短期的利益ではなく長期のキャリアに向き合う',
            text: '私たちの目的は、単に現時点での仕事の選択や一時的なキャリアの成功に焦点を当てることではありません。あなたの将来を見据え、持続的な成長と充実感を追求するために、長期的なキャリア戦略を構築していきます。',
            img: 'value02.png',
        },
        {
            main: '転職をゴールとしない',
            text: '私たちのアプローチは、一人ひとりに向き合い、個々のニーズや目標に合わせたキャリア面談を通じて展開されます。私たちは、あなたの強みやスキル、興味について深く理解し、それらを最大限に活かすための情報を提供します。',
            img: 'value03.png',
        },
        {
            main: '対等な関係でサポートする',
            text: '私たちは、対等な関係のもとであなたをサポートし、キャリアの成長と達成を共に追求します。自己成長を実現するための重要な要素として、あなたの意見やフィードバックを積極的に受け入れ、共に議論し、意思決定に対して建設的なサポートを提供します。',
            img: 'value04.png',
        },
    ];

    valueItems.forEach((valueItem) => {
        valueItem.addEventListener('mouseover', (event) => {
            const number = [].slice.call(valueItems).indexOf(valueItem);
            const imgSrc = /value\d\d.png/;
            valueImg.src = valueImg.src.replace(imgSrc, coreValues[number].img);
            valueMain.textContent = coreValues[number].main;
            valueText.textContent = coreValues[number].text;

        });
    });

    console.log(valueMain);
}
